import React, { useState, useEffect } from 'react';
import { ChangeEvent } from 'react';

import environment from './environment/environment';

import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import theme from './theme';

import { useAuth, useProcess, useError } from './context/stateContext';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Container from '@material-ui/core/Container';
import Tab from '@material-ui/core/Tab';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import CircularProgress from '@material-ui/core/CircularProgress';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';

import ExportAll from './components/export-all/ExportAll';
import ExportProject from './components/export-project/ExportProject';
import tokenResponseInterface from './types/tokenResponseInterface';
import tokenClientConfigInterface from './types/tokenClientConfigInterface';

const App = () => {
  const { setAuth, isSignedIn, signIn, signOut, setToken } = useAuth();

  const { process, setProcess } = useProcess();

  const [activeTab, setActiveTab] = useState('0');

  const { error, setError } = useError();

  useEffect(() => {
    setProcess('Loading Gapi API');

    const tokenClientConfig: tokenClientConfigInterface = {
      client_id: environment.client_id,
      discoveryDocs: environment.discoveryDocs,
      scope: environment.scope,
      callback: (tokenResponse: tokenResponseInterface) => {
        const { access_token } = tokenResponse;
        if (access_token) {
          setToken(access_token);
        }
      },
    };

    const auth = google.accounts.oauth2.initTokenClient(tokenClientConfig);
    setAuth(auth);
    setProcess(null);
  }, [setAuth, setError, setProcess, setToken]);

  const onSignIn = () => {
    signIn();
  };

  const onSignOut = () => {
    signOut();
  };

  const onChangeActiveTab = (event: ChangeEvent<{}>, newValue: string) => {
    setActiveTab(newValue);
  };

  const onCloseError = () => {
    setError(null);
  };

  return (
    <MuiThemeProvider theme={theme}>
      <AppBar position="static">
        <Toolbar>
          <span>AgileTW Export</span>
          {!isSignedIn && (
            <div
              style={{
                userSelect: 'none',
                cursor: 'pointer',
                marginLeft: 'auto',
                display: 'flex',
                gap: '6px',
                alignItems: 'center',
              }}
              onClick={onSignIn}
            >
              <p>Login</p>
              <span className="material-icons">login</span>
            </div>
          )}
          {isSignedIn && (
            <div
              style={{
                userSelect: 'none',
                cursor: 'pointer',
                marginLeft: 'auto',
                display: 'flex',
                gap: '6px',
                alignItems: 'center',
              }}
              onClick={onSignOut}
            >
              <p>Logout</p>
              <span className="material-icons">logout</span>
            </div>
          )}
        </Toolbar>
      </AppBar>
      {isSignedIn ? (
        <Container maxWidth="lg">
          <TabContext value={activeTab}>
            <TabList
              onChange={onChangeActiveTab}
              indicatorColor="primary"
              textColor="primary"
              centered
            >
              <Tab
                label="All"
                value="0"
              />
              <Tab
                label="Project"
                value="1"
              />
            </TabList>
            <TabPanel value="0">
              <ExportAll />
            </TabPanel>
            <TabPanel value="1">
              <ExportProject />
            </TabPanel>
          </TabContext>
        </Container>
      ) : (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '4rem' }}>
          <Button
            onClick={onSignIn}
            color="primary"
            variant="contained"
            size="large"
          >
            Login
          </Button>
        </div>
      )}
      <Dialog
        style={{ textAlign: 'center' }}
        open={!!process}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>{process}</DialogTitle>
        <DialogContent>
          <CircularProgress />
        </DialogContent>
      </Dialog>
      <Dialog
        style={{ textAlign: 'center' }}
        open={!!error}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>ERROR</DialogTitle>
        <DialogContent>{error}</DialogContent>
        <DialogActions>
          <Button
            color="primary"
            onClick={onCloseError}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </MuiThemeProvider>
  );
};

export default App;
